import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { motion } from "framer-motion";
import { MaskLine } from "@/components/Reveal";

export default function PageHero({ title, subtitle, image, crumbs = [] }) {
  return (
    <section className="relative pt-36 pb-16 md:pt-44 md:pb-20 overflow-hidden bg-navy-deep" data-testid="page-hero">
      <div className="absolute inset-0">
        {image && <img src={image} alt="" className="w-full h-full object-cover opacity-35" />}
        <div className="absolute inset-0 bg-gradient-to-b from-navy-deep/70 via-navy-deep/80 to-navy-deep" />
      </div>
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10">
        <nav className="flex items-center gap-2 text-xs text-slate-400 mb-5">
          <Link to="/" className="hover:text-sky">Home</Link>
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-2">
              <ChevronRight className="h-3 w-3" />
              {c.to ? <Link to={c.to} className="hover:text-sky">{c.label}</Link> : <span className="text-sky">{c.label}</span>}
            </span>
          ))}
        </nav>
        <h1 className="font-display text-4xl md:text-6xl font-extrabold text-white leading-[1.02] max-w-4xl">
          <MaskLine>{title}</MaskLine>
        </h1>
        {subtitle && (
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.4 }} className="text-slate-300 mt-4 max-w-2xl text-base md:text-lg">
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
